/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Preset_Manager_Export_All_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to export presets: {error}" |
*
* @param {Preset_Manager_Export_All_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_all_failed_toast = /** @type {((inputs: Preset_Manager_Export_All_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_All_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'exportation des presets : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellungen konnten nicht exportiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile esportare i preset: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось экспортировать предустановки: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar ajustes preestablecidos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出预设失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセットのエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट निर्यात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao exportar predefinições: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to export presets: ${i?.error}`)
});